export default __webpack_public_path__ + "static/media/customization.f0a0ba6b.png";